import useSWR from 'swr';
import { useContext } from 'react';
import { FixtureAudio } from '@/service/types';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { ScoringContext } from '@/contexts/scoring/context';
import {
  SERVICE_ENDPOINT,
  fetchFromMTService,
} from '../fetcher/monitoringToolService';
import { HTTP_STATUS_CODE } from '../constants';
import { ApiError } from '../ApiError';

export const useFixtureAudio = () => {
  const token = useAuthToken();

  const {
    state: { fixtureId },
  } = useContext(ScoringContext);

  const { data, error, mutate } = useSWR<FixtureAudio[], ApiError>(
    token && fixtureId
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.FixtureAudio(fixtureId).allRecords.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        if (e.status === HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    allRecords: data,
    mutate,
    error,
    isLoading: !data && !error,
  };
};
